import { createApi } from '@reduxjs/toolkit/query/react';
import apiBaseQuery from './axiosBaseQuery'
export const COUNTER_PARTY_API_REDUCER_KEY = 'counterPartiesApi';


export const counterPartiesApi = createApi({
    reducerPath: COUNTER_PARTY_API_REDUCER_KEY,
    baseQuery: apiBaseQuery,
    tagTypes: ['counterparties'],
    endpoints: (builder) => ({
        getAllCounterParties: builder.query({
            query: ({ page, q, country, limit }) => ({
                url: `admin/repository/counterparties?page=${page}&q=${q}&country=${country}&limit=${limit}`
            }),
            providesTags: ['counterparties']
        }),
        getCounterParties: builder.query({
            query: (id) => ({
                url: `admin/repository/counterparties/${id}`
            }),
            providesTags: ['counterparties']
        }),
        createCounterParties: builder.mutation({
            query: (body) => ({
                url: `admin/repository/counterparties`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ['counterparties']
        }),
        updateCounterParties: builder.mutation({
            query: ({ id, ...rest }) => ({
                url: `admin/repository/counterparties/${id}`,
                method: 'PUT',
                body: rest
            }),
            invalidatesTags: ['counterparties']
        }),
    })
});

export const {
    useGetAllCounterPartiesQuery,
    useGetCounterPartiesQuery,
    useCreateCounterPartiesMutation,
    useUpdateCounterPartiesMutation,
} = counterPartiesApi;